import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DirectAccessGuard } from "../../common/services/direct-access-guard";
import { VarietyProfileComponent } from "./roof-panel/variety-profile/variety-profile.component";
import { DetailsStaticsComponent } from './roof-panel/details-statics/details-statics.component';
import { RoofPlanComponent } from './roof-plan.component';
import { RoofMountingComponent } from './roof-mounting/roof-mounting.component';
import { RoofShapeComponent } from './roof-shape/roof-shape.component';
import { RoofStructureComponent } from './roof-structure/roof-structure.component';
import { RoofPanelComponent } from './roof-panel/roof-panel.component';
import { RoofItemListComponent } from './roof-item-list/roof-item-list.component';
import { MountPurlinComponent } from './roof-structure/mount-purlin/mount-purlin.component';
import { MountRafterComponent } from './roof-structure/mount-rafter/mount-rafter.component';
import { BeamDistanceControlComponent } from './roof-structure/beam-distance-control/beam-distance-control.component';
import { RoofHookComponent } from './roof-structure/roof-hook/roof-hook.component';
import { TrapezDirectComponent } from './roof-structure/trapez-direct/trapez-direct.component';
import { SharedModule } from "../../shared.module";

const routes: Routes = [
  {
    path: '',
    component: RoofPlanComponent,
    children: [
      {
        path: 'mounting',
        component: RoofMountingComponent,
        canActivate: [DirectAccessGuard]
      },
      {
        path: 'shape',
        component: RoofShapeComponent,
        canActivate: [DirectAccessGuard]
      },
      {
        path: 'structure',
        component: RoofStructureComponent,
        canActivate: [DirectAccessGuard]
      },
      {
        path: 'panel',
        component: RoofPanelComponent,
        canActivate: [DirectAccessGuard]
      },
      {
        path: 'itemList',
        component: RoofItemListComponent,
        canActivate: [DirectAccessGuard]
      }
    ]
  }
]
@NgModule({
  imports: [
    RouterModule.forChild(routes),
    SharedModule
  ],
  exports: [RouterModule],
  declarations: [
    RoofPlanComponent,
    RoofMountingComponent,
    RoofShapeComponent,
    RoofStructureComponent,
    RoofPanelComponent,
    RoofItemListComponent,
    MountPurlinComponent,
    TrapezDirectComponent,
    BeamDistanceControlComponent,
    RoofHookComponent,
    MountRafterComponent,
    VarietyProfileComponent,
    DetailsStaticsComponent
  ]
})
export class RoofPlanRoutingModule { }
